import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-779d0c99"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "screen-overlay" }, null, -1))
const _hoisted_2 = { class: "sticky" }
const _hoisted_3 = { class: "navbar navbar-expand-lg navbar-light fixed-top bg-light" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#mobile_menu",
  "aria-controls": "mobile_menu",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_6 = {
  class: "collapse navbar-collapse d-flex align-items-center",
  id: "mobile_menu"
}
const _hoisted_7 = { class: "navbar-nav mx-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "active-border" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "active-border" }, null, -1))
const _hoisted_10 = { class: "nav-item dropdown" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " Reports ", -1))
const _hoisted_12 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_13 = { class: "nav-item dropdown" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " Requests ", -1))
const _hoisted_15 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "active-border" }, null, -1))
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "active-border" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<li class=\"nav-item\" data-v-779d0c99><a class=\"nav-link\" href=\"https://map.admin.caprock.com.au/agreement-doc-view/cash_account_agreement\" target=\"_blank\" data-v-779d0c99>Platform Agreement</a><div class=\"active-border\" data-v-779d0c99></div></li><li class=\"nav-item\" data-v-779d0c99><a class=\"nav-link\" href=\"https://map.admin.caprock.com.au/agreement-doc-view/information_memorandum\" target=\"_blank\" data-v-779d0c99>IM Agreement</a><div class=\"active-border\" data-v-779d0c99></div></li>", 2)
const _hoisted_22 = { class: "navbar-nav ml-auto d-flex align-items-center mr-4" }
const _hoisted_23 = { class: "nav-item mr-4" }
const _hoisted_24 = { class: "dropdown" }
const _hoisted_25 = {
  class: "dropdown-toggle header-user-account",
  id: "profile-options",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_26 = { style: {"height":"40px","width":"40px"} }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "font-size-16" }
const _hoisted_29 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  class: "modal fade",
  id: "transaction_report",
  style: {"background":"#a9a9a93d"},
  "aria-labelledby": "transaction_report",
  "aria-hidden": "true"
}
const _hoisted_32 = { class: "modal-dialog" }
const _hoisted_33 = { class: "modal-content" }
const _hoisted_34 = {
  class: "modal-header",
  style: {"padding":"0.4rem 0.5rem","background":"#005288"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "font-size-16 font-white p-cursor",
  id: "transaction_report"
}, "Transaction Report", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5932 11.3926L11.4053 18.5806",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5954 18.5847L11.4014 11.3892",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M21.5017 1.125H8.49823C3.96673 1.125 1.12573 4.3335 1.12573 8.874V21.126C1.12573 25.6665 3.95323 28.875 8.49823 28.875H21.5002C26.0467 28.875 28.8757 25.6665 28.8757 21.126V8.874C28.8757 4.3335 26.0467 1.125 21.5017 1.125Z",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "modal-body" }
const _hoisted_39 = { class: "card p-4 mb-1 bg-card-light border-radius-10 h-100" }
const _hoisted_40 = { style: {"color":"red"} }
const _hoisted_41 = { style: {"color":"green"} }
const _hoisted_42 = { class: "row mx-1" }
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Accounts", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Select Account", -1))
const _hoisted_47 = ["value", "data-name"]
const _hoisted_48 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Sub Accounts", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Select Sub Account", -1))
const _hoisted_52 = ["data-id", "value"]
const _hoisted_53 = { class: "col-md-12" }
const _hoisted_54 = { class: "form-group" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Type", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "All", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "custom" }, "Custom", -1))
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "From Date", -1))
const _hoisted_62 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "To Date", -1))
const _hoisted_65 = { class: "col-md-12 text-center" }
const _hoisted_66 = {
  class: "modal fade",
  id: "portfolio_report",
  style: {"background":"#a9a9a93d"},
  "aria-labelledby": "portfolio_report",
  "aria-hidden": "true"
}
const _hoisted_67 = { class: "modal-dialog" }
const _hoisted_68 = { class: "modal-content" }
const _hoisted_69 = {
  class: "modal-header",
  style: {"padding":"0.4rem 0.5rem","background":"#005288"}
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "font-size-16 font-white p-cursor",
  id: "portfolio_report"
}, "Portfolio Report", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5932 11.3926L11.4053 18.5806",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5954 18.5847L11.4014 11.3892",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M21.5017 1.125H8.49823C3.96673 1.125 1.12573 4.3335 1.12573 8.874V21.126C1.12573 25.6665 3.95323 28.875 8.49823 28.875H21.5002C26.0467 28.875 28.8757 25.6665 28.8757 21.126V8.874C28.8757 4.3335 26.0467 1.125 21.5017 1.125Z",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "modal-body" }
const _hoisted_74 = { class: "card p-4 mb-1 bg-card-light border-radius-10 h-100" }
const _hoisted_75 = { style: {"color":"red"} }
const _hoisted_76 = { style: {"color":"green"} }
const _hoisted_77 = { class: "row mx-1" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h5", { style: {"font-weight":"100 !important","font-size":"1.25rem","color":"#4b4949"} }, "Are you sure you want to generate portfolio report ? ")
], -1))
const _hoisted_79 = { class: "col-md-12 text-center" }
const _hoisted_80 = {
  class: "modal fade",
  id: "notice_alert",
  style: {"background":"#a9a9a93d"},
  "aria-labelledby": "notice_alert",
  "aria-hidden": "true"
}
const _hoisted_81 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_82 = { class: "modal-content" }
const _hoisted_83 = {
  class: "modal-header",
  style: {"padding":"0.4rem 0.4rem","background":"#262424"}
}
const _hoisted_84 = { class: "font-size-16 font-white p-cursor" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5932 11.3926L11.4053 18.5806",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5954 18.5847L11.4014 11.3892",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M21.5017 1.125H8.49823C3.96673 1.125 1.12573 4.3335 1.12573 8.874V21.126C1.12573 25.6665 3.95323 28.875 8.49823 28.875H21.5002C26.0467 28.875 28.8757 25.6665 28.8757 21.126V8.874C28.8757 4.3335 26.0467 1.125 21.5017 1.125Z",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = { class: "modal-body" }
const _hoisted_88 = { class: "card p-4 mb-1 bg-card-light border-radius-10 h-100" }
const _hoisted_89 = { class: "row mx-1" }
const _hoisted_90 = { class: "col-md-12" }
const _hoisted_91 = { style: {"font-weight":"100 !important","font-size":"1rem","color":"#4b4949"} }
const _hoisted_92 = { class: "col-md-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_toast = _resolveComponent("toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.load_on==1)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "navbar-brand d-flex align-items-center",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.merchant_logo_url,
              class: "img-fluid mx-2",
              style: {"width":"auto","height":"38px"}
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", {
              class: _normalizeClass(["nav-item", { active: _ctx.active_page== 'dashboard'}])
            }, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Dashboard ")
                ]),
                _: 1
              }),
              _hoisted_8
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["nav-item", { active: _ctx.active_page== 'profile'}])
            }, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/my-profile"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" My Profile ")
                ]),
                _: 1
              }),
              _hoisted_9
            ], 2),
            _createElementVNode("li", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.open_report(1);}),
                  href: "#"
                }, "Transaction"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.open_report(2);}),
                  href: "#"
                }, "Portfolio")
              ])
            ]),
            _createElementVNode("li", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_router_link, {
                  class: "dropdown-item",
                  to: "/credit-request"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Credit")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "dropdown-item",
                  to: "/debit-request"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Debit")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/terms-of-use",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Terms of use ")
                ]),
                _: 1
              }),
              _hoisted_17
            ]),
            _createElementVNode("li", _hoisted_18, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/privacy-policy",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Privacy Policy ")
                ]),
                _: 1
              }),
              _hoisted_19
            ]),
            _hoisted_20
          ]),
          _createElementVNode("ul", _hoisted_22, [
            _createElementVNode("li", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("img", {
                      style: {"height":"38px","width":"38px","border-radius":"50%","object-fit":"cover"},
                      onError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadImage())),
                      src: _ctx.profile_url,
                      class: "mr-2"
                    }, null, 40, _hoisted_27)
                  ]),
                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.user_name), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.user_is_director!=1)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "dropdown-item",
                        to: "/my-profile"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" My Account ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.user_is_director==1)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: _normalizeClass([{'active_profile_menu':_ctx.profile_type=='my'}, "dropdown-item"]),
                        href: "#",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switch_profile('my')))
                      }, " Individual Account ", 2))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businesses, (business, I) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: I,
                      class: _normalizeClass([{'active_profile_menu':_ctx.profile_type=='business_'+business.company_no}, "dropdown-item"]),
                      href: "#",
                      onClick: ($event: any) => (_ctx.switch_profile('business',business.company_no))
                    }, _toDisplayString(business.company_name), 11, _hoisted_30))
                  }), 128)),
                  _createVNode(_component_router_link, {
                    class: "dropdown-item",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.logout(1);}),
                    to: "#"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Logout ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("span", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => {(_ctx.$refs['toast'] as any).closeModal('transaction_report');}),
              style: {"cursor":"pointer"}
            }, _hoisted_37)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.erorr), 1),
              _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.success), 1),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("select", {
                      onChange: _cache[6] || (_cache[6] = ($event: any) => {_ctx.fetch_subaccounts($event);}),
                      class: "form-control",
                      name: "account"
                    }, [
                      _hoisted_46,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.u_accounts, (c, I) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: I,
                          value: c.userac_id,
                          "data-name": c.ac_slug
                        }, _toDisplayString(c.ac_name), 9, _hoisted_47))
                      }), 128))
                    ], 32)
                  ])
                ]),
                (_ctx.form.userac_id>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("select", {
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.set_subac($event))),
                          class: "form-control",
                          name: "sub_account"
                        }, [
                          _hoisted_51,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.us_accounts, (subac) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: subac.subac_id,
                              "data-id": 'subTitle'+subac.subac_id,
                              value: subac.subac_id
                            }, _toDisplayString(subac.subac_name) + " (" + _toDisplayString(subac.currency_name) + ") ", 9, _hoisted_52))
                          }), 128))
                        ], 32)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.ttype) = $event)),
                      class: "form-control",
                      name: "ttype"
                    }, _hoisted_58, 512), [
                      [_vModelSelect, _ctx.form.ttype]
                    ])
                  ])
                ]),
                (this.form.ttype=='custom')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.from_date) = $event)),
                          type: "date",
                          class: "form-control",
                          name: "from_date"
                        }, null, 512), [
                          [_vModelText, _ctx.form.from_date]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (this.form.ttype=='custom')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.to_date) = $event)),
                          type: "date",
                          class: "form-control",
                          name: "to_date"
                        }, null, 512), [
                          [_vModelText, _ctx.form.to_date]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.generate_trans_report();}),
                    type: "button",
                    class: "btn btn-orange font-white rounded-pill subBtn",
                    style: {"padding":"6px 40px","text-align":"center"}
                  }, "Generate Now")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("span", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => {(_ctx.$refs['toast'] as any).closeModal('portfolio_report');}),
              style: {"cursor":"pointer"}
            }, _hoisted_72)
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.erorr), 1),
              _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.success), 1),
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("button", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.generate_portfolio_report();}),
                    type: "button",
                    class: "mr-2 btn btn-orange font-white subBtn portReportBtn rounded-pill",
                    style: {"padding":"6px 40px","text-align":"center"}
                  }, "Yes"),
                  _createElementVNode("button", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => {(_ctx.$refs['toast'] as any).closeModal('portfolio_report');}),
                    type: "button",
                    class: "ml-2 noBtn btn btn-primary font-white rounded-pill",
                    style: {"padding":"6px 40px","text-align":"center"}
                  }, "No")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_80, [
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("h5", _hoisted_84, _toDisplayString(_ctx.popupTitle), 1),
            _createElementVNode("span", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.closeNotice();}),
              style: {"cursor":"pointer"}
            }, _hoisted_86)
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("p", _hoisted_91, _toDisplayString(_ctx.popupMessage), 1)
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("button", {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeNotice())),
                    type: "button",
                    class: "ml-2 noBtn btn btn-dark font-white rounded-pill",
                    style: {"padding":"6px 40px","text-align":"center"}
                  }, "Okay")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toast, { ref: "toast" }, null, 512)
  ], 64))
}